import React from "react";
import { PieChart, Pie, Cell, Label, Sector, SectorProps } from "recharts";

type Props = {
  innerRadius: number;
  outerRadius: number;
  innerText?: string;
  data: { name: string; value: number; fill: string }[];
  percent?: number;
};

const LinePieChart = ({
  innerRadius,
  outerRadius,
  innerText,
  data,
  percent,
}: Props) => {
  const renderActiveShape = ({
    cx,
    cy,
    innerRadius: innerRadiusProp,
    outerRadius: outerRadiusProp,
    startAngle,
    endAngle,
  }: SectorProps) => {
    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          cornerRadius={10}
          innerRadius={innerRadiusProp}
          outerRadius={outerRadiusProp}
          startAngle={startAngle}
          endAngle={endAngle}
          // D-05: active pie SECTOR fill is a chart data-series color — left as #040b44, not rebranded
          fill="#040b44"
        />
      </g>
    );
  };

  return (
    // D-10: charts keep their natural (LTR) orientation in both languages.
    <div dir="ltr" style={{ display: "inline-block" }}>
      <PieChart width={innerText ? 200 : 50} height={innerText ? 200 : 50}>
        <Pie
          activeIndex={0}
          activeShape={renderActiveShape}
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={90} // This is for the direction to be clockwise
          endAngle={-270} // This is for the direction to be clockwise
        >
          {data.map((entry) => (
            <Cell key={`cell-${entry.name}`} fill={entry.fill} />
          ))}
          <Label
            value={`${percent}%`}
            position="center"
            fontSize={innerText ? 18 : 12}
            fill="#1E1E1E" // $brand-black (elements.scss) — chart center-label text chrome (not a data series), recolored per D-04
            fontWeight="bold"
            dy={innerText ? -10 : 0}
          />
          {innerText && (
            <Label
              value={innerText}
              position="center"
              fontSize={16}
              fill="#1E1E1E" // $brand-black (elements.scss) — chart center inner-text label chrome (not a data series), recolored per D-04
              dy={10}
            />
          )}
        </Pie>
      </PieChart>
    </div>
  );
};

export default LinePieChart;
